import { useState } from "react";
import Seo from "../components/Seo";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Contact() {
  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  };

  const [captchaCode, setCaptchaCode] = useState(generateCaptcha());

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
    captcha: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.captcha.toUpperCase() !== captchaCode) {
      setResponseMsg("Invalid CAPTCHA. Please try again.");
      setCaptchaCode(generateCaptcha());
      return;
    }

    setLoading(true);
    setResponseMsg("");

    try {
      const payload = {
        ...formData,
        captchaCode: formData.captcha,
        captcha: captchaCode,
      };

      const res = await fetch("https://raimetalsapi.anaxistech.com/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setResponseMsg("Message sent successfully!");

        setFormData({
          name: "",
          email: "",
          subject: "",
          phone: "",
          message: "",
          captcha: "",
        });
        setCaptchaCode(generateCaptcha());
      } else {
        setResponseMsg(data.message || "Something went wrong.");
      }
    } catch (error) {
      setResponseMsg("Server error. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen pt-[76px] text-white md:pt-[114px]">
      <Seo
        title="Contact Rai Metals | Request Scrap Metal Quote"
        description="Contact Rai Metals for scrap metal sourcing, pricing, and global trading inquiries. Request a quote for ferrous and non-ferrous materials."
        keywords="contact Rai Metals, scrap metal quote, metal supplier inquiry, ferrous scrap pricing, non-ferrous scrap"
        robots="index, follow"
        canonicalPath="/contact"
        image="/uploads/Logo1.jpeg"
      />

      <section className="page-section border-b border-gold/10">
        <div className="mx-auto max-w-7xl">
          <div className="mb-12">
            <span className="section-tag">Get in Touch</span>
            <h1 className="section-title">
              Request a <span className="text-gold">Quote</span>
            </h1>
            <p className="max-w-2xl text-gray-400">
              Share your requirement and our team will respond with pricing, material availability, and next steps.
            </p>
          </div>

          <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
            <div className="space-y-6">
              <div className="metal-panel rounded-xl p-6">
                <p className="mb-2 text-sm text-[#c9a34e]">ADDRESS</p>
                <p className="text-gray-300">5103 Ashcrest Ct, Tampa, Florida 33647</p>
              </div>

              <div className="metal-panel rounded-xl p-6">
                <p className="mb-2 text-sm text-[#c9a34e]">PHONE</p>
                <p className="text-gray-300">+1 980-229-1914</p>
              </div>

              <div className="metal-panel rounded-xl p-6">
                <p className="mb-2 text-sm text-[#c9a34e]">EMAIL</p>
                <p className="text-gray-300">amar@raimetals.net</p>
              </div>
            </div>

            <form
              onSubmit={handleSubmit}
              className="metal-panel grid gap-5 rounded-xl p-4 shadow-metal sm:p-6 md:p-8 lg:p-10"
            >
              <div className="mb-1 border-b border-[#2a2a2a] pb-4">
                <p className="text-xs uppercase tracking-[0.25em] text-gray-400">Inquiry Form</p>
                <h2 className="mt-1 text-2xl font-bold text-white">Tell us what you need</h2>
              </div>

              <div className="grid gap-5 md:grid-cols-2">
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-[0.15em] text-gray-400">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="input"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-[0.15em] text-gray-400">Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="input"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-[0.15em] text-gray-400">Company</label>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Company"
                    value={formData.subject}
                    onChange={handleChange}
                    className="input"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-[0.15em] text-gray-400">Phone</label>
                  <PhoneInput
                    country={"in"}
                    value={formData.phone}
                    onChange={(phone) => setFormData({ ...formData, phone })}
                    inputClass="phone-input"
                    buttonClass="phone-button"
                    containerClass="phone-container"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-xs uppercase tracking-[0.15em] text-gray-400">Message</label>
                <textarea
                  name="message"
                  placeholder="Estimated quantity & details..."
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  required
                  className="input"
                />
              </div>

              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
                <div className="w-full rounded-lg border border-[#2a2a2a] bg-black px-4 py-3 text-center font-bold tracking-[0.35em] text-[#c9a34e] sm:w-auto sm:px-6">
                  {captchaCode}
                </div>

                <button
                  type="button"
                  onClick={() => setCaptchaCode(generateCaptcha())}
                  className="w-full rounded-lg border border-[#2a2a2a] px-4 py-3 transition-colors hover:border-[#c9a34e] sm:w-auto"
                >
                  Refresh
                </button>

                <input
                  type="text"
                  name="captcha"
                  placeholder="Enter code"
                  value={formData.captcha}
                  onChange={handleChange}
                  required
                  className="input w-full sm:flex-1"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="mt-4 rounded-lg bg-[#c9a34e] py-3 font-semibold text-black transition-opacity hover:opacity-90"
              >
                {loading ? "Sending..." : "Send Inquiry ->"}
              </button>

              {responseMsg && <p className="text-sm text-green-400">{responseMsg}</p>}
            </form>
          </div>
        </div>
      </section>

      <style jsx>{`
        .input {
          background: #0b0b0b;
          border: 1px solid #2a2a2a;
          padding: 12px 14px;
          border-radius: 8px;
          color: white;
          outline: none;
          width: 100%;
        }

        .input:focus {
          border-color: #c9a34e;
          box-shadow: 0 0 0 1px #c9a34e;
        }

        .phone-input {
          width: 100% !important;
          background: #0b0b0b !important;
          border: 1px solid #2a2a2a !important;
          color: white !important;
          border-radius: 10px !important;
          height: 48px !important;
        }

        .phone-button {
          background: #0b0b0b !important;
          border: 1px solid #2a2a2a !important;
          border-right: none !important;
        }
      `}</style>
    </div>
  );
}

export default Contact;
